import { FC, Fragment } from 'react';
import { Divider } from '~/components/ui/Divider';
import { IModalState, ModalType } from '~/shared';
import { ModalAdminRequest } from '../ModalAdminRequest';
import { ModalBusinessChangePrice } from '../ModalBusinessChangePrice';
import { ModalBusinessOrder } from '../ModalBusinessOrder';
import { ModalBusinessWithdraw } from '../ModalBusinessWithdraw';
import { ModalCountAndPrice } from '../ModalCountAndPrice';
import { ModalDefault } from '../ModalDefault';
import { ModalPrice } from '../ModalPrice';
import { ModalTitle } from '../ModalTitle';
import { ModalVehicleTestDrive } from '../ModalVehicleTestDrive';
import { StyledContainer } from './ModalContent.styled';

type SupportedModalType = Exclude<ModalType, ModalType.Invite>;

const modalTypes: Record<SupportedModalType, FC<{ state: any }>> = {
	[ModalType.Default]: ModalDefault,
	[ModalType.Price]: ModalPrice,
	[ModalType.VehicleTestDrive]: ModalVehicleTestDrive,
	[ModalType.CountAndPrice]: ModalCountAndPrice,
	[ModalType.BusinessWithdraw]: ModalBusinessWithdraw,
	[ModalType.BusinessChangePrice]: ModalBusinessChangePrice,
	[ModalType.BusinessOrder]: ModalBusinessOrder,
	[ModalType.AdminRequest]: ModalAdminRequest,
};

interface IModalContentProps {
	state: IModalState;
}

const ModalContent: React.FC<IModalContentProps> = ({ state }) => {
	if (state.type === ModalType.Invite) {
		return null;
	}

	const ModalByType = modalTypes[state.type as SupportedModalType] ?? Fragment;

	return (
		<StyledContainer>
			<ModalTitle state={state} />
			<Divider $direction={'H'} style={{ opacity: 0.1 }} />
			<ModalByType state={state} />
		</StyledContainer>
	);
};

export { ModalContent };
